import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faTimes } from '@fortawesome/free-solid-svg-icons';

const EditModal = ({ children, onClose, onBack, showBackButton }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      <div
        className='col-9 col-md-6 col-lg-6'
        style={{
          backgroundColor: '#0B0E1E',
          borderRadius: '8px',
          padding: '20px',
          // minWidth: '650px',
          position: 'relative',
          border: '1px solid #AEAFBA',
        }}
      >
        {/* Back Button */}
        {showBackButton && (
          <button
            onClick={onBack}
            style={{
              position: 'absolute',
              top: '10px',
              left: '13px',
              background: 'none',
              color: 'white',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
            }}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
        )}

        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'none',
            color: 'white',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        {/* Modal Content */}
        {children}
      </div>
    </div>
  );
};

export default EditModal;